/**
 * @fileoverview GET handler for the "/recently_visited" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { recentlyVisited } from "./constants";
import type { RecentlyVisitedResult } from "./types";

export const getRecentlyVisited = reactQueryFetcherAdapter(
  recentlyVisited,
  (signal: AbortSignal, includeArchive: boolean, activeDraftOnly: boolean): Promise<RecentlyVisitedResult> => {
    return fetch(
      "/recently_visited",
      "GET",
      { include_archive: includeArchive, include_active_draft_only: activeDraftOnly },
      { signal }
    );
  }
);
